import React from "react";
import {
  Redirect,
  Switch,
  Route
} from "react-router-dom";
import ResponsiveHelmet from "./responsive_helmet.js";
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import LeftMenu from '../../admin/layout/left_menu.js';
import TopBar from '../../admin/layout/top_bar.js';

import ModalContainer from "../../admin/modals/container.js";

import MailerReadmePage from "../../admin/pages/mailer_readme/mailer_readme_page.js";
import NewsletterEmailsPage from "../../admin/pages/newsletter_emails/newsletter_emails_page.js"

import ProjectsListPage from "../../admin/pages/projects/list/projects_list_page.js";
import ProjectInfoPage from "../../admin/pages/projects/info/project_info_page.js";

import UsersListPage from "../../admin/pages/users/list/users_list_page.js";
import UserInfoPage from "../../admin/pages/users/info/user_info_page.js";

import PagesListPage from "../../admin/pages/pages/list/pages_list_page.js";
import PageInfoPage from "../../admin/pages/pages/info/page_info_page.js";

import DownloadablesListPage from "../../admin/pages/downloadables/list/downloadables_list_page.js";
import DownloadableInfoPage from "../../admin/pages/downloadables/info/downloadable_info_page.js";

import DevelopersListPage from "../../admin/pages/developers/list/developers_list_page.js";
import DeveloperInfoPage from "../../admin/pages/developers/info/developer_info_page.js";

import CountriesListPage from "../../admin/pages/countries/list/countries_list_page.js";
import CountryInfoPage from "../../admin/pages/countries/info/country_info_page.js";

import CompaniesListPage from "../../admin/pages/companies/list/companies_list_page.js";
import CompanyInfoPage from "../../admin/pages/companies/info/company_info_page.js";

import StatisticsListPage from "../../admin/pages/statistics/statistics_list_page.js";

import Routes from "../../admin/routes.js";
import { TopBarHeight, LeftMenuWidth } from "../../admin/constants.js";

const styles = theme => ({
  root: {
    position: "absolute",
    top: TopBarHeight,
    left: LeftMenuWidth,
    right: "0px",
    bottom: "0px"
  },
  content: {
    width: "100%",
    height: '100%',
    position: "relative",
    overflow: "hidden"
  }
});

class Admin extends React.Component  {

  render() {
    const { classes } = this.props;

    return <React.Fragment>
      <ResponsiveHelmet />
      <TopBar />
      <LeftMenu />
      <div className = { classes.root } >
        <main className = { classes.content } >
          <Switch>
            <Redirect exact 
                      from = { Routes.index() }
                      to = { Routes.projectsList() } />
            <Route exact 
                   sensitive 
                   path = { Routes.projectsList() }
                   render = { ({ match }) => {
                     return <ProjectsListPage key = { match.url }
                                              match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.project("new") }
                   render = { ({ match }) => {
                     return <ProjectInfoPage key = { match.url }
                                             match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.project() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <ProjectInfoPage key = { match.url }
                                             match = { match }
                                             identifier = { params.identifier } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.usersList() }
                   render = { ({ match }) => {
                     return <UsersListPage key = { match.url }
                                           match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.user() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <UserInfoPage key = { match.url }
                                          match = { match }
                                          identifier = { params.identifier } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.pagesList() }
                   render = { ({ match }) => {
                     return <PagesListPage key = { match.url }
                                           match = { match } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.page("new") }
                   render = { ({ match }) => {
                     return <PageInfoPage key = { match.url }
                                             match = { match } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.page() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <PageInfoPage key = { match.url }
                                          match = { match }
                                          identifier = { params.identifier } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.downloadablesList() }
                   render = { ({ match }) => {
                     return <DownloadablesListPage key = { match.url }
                                           match = { match } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.downloadable("new") }
                   render = { ({ match }) => {
                     return <DownloadableInfoPage key = { match.url }
                                             match = { match } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.downloadable() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <DownloadableInfoPage key = { match.url }
                                          match = { match }
                                          identifier = { params.identifier } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.companiesList() }
                   render = { ({ match }) => {
                     return <CompaniesListPage key = { match.url }
                                               match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.company("new") }
                   render = { ({ match }) => {
                     return <CompanyInfoPage key = { match.url }
                                             match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.company() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <CompanyInfoPage key = { match.url }
                                             match = { match }
                                             identifier = { params.identifier } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.developersList() }
                   render = { ({ match }) => {
                     return <DevelopersListPage key = { match.url }
                                                match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.developer("new") }
                   render = { ({ match }) => {
                     return <DeveloperInfoPage key = { match.url }
                                               match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.developer() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <DeveloperInfoPage key = { match.url }
                                               match = { match }
                                               identifier = { params.identifier } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.countriesList() }
                   render = { ({ match }) => {
                      return <CountriesListPage key = { match.url }
                                                match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.country("new") }
                   render = { ({ match }) => {
                     return <CountryInfoPage key = { match.url }
                                             match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.country() }
                   render = { ({ match }) => {
                     const { params } = match;
                     return <CountryInfoPage key = { match.url }
                                             match = { match }
                                             identifier = { params.identifier } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.mailerReadme()}
                   render = { ({ match }) => {
                     return <MailerReadmePage key = { match.url }
                                              match = { match } />
            }} />
            <Route exact
                   sensitive
                   path = { Routes.newsletterEmails()}
                   render = { ({ match }) => {
                     return <NewsletterEmailsPage key = { match.url }
                                              match = { match } />
            }} />
            <Route exact 
                   sensitive 
                   path = { Routes.statistics()}
                   render = { ({ match }) => {
                     return <StatisticsListPage key = { match.url }
                                                match = { match } />
            }} />
          </Switch>
        </main>
        <ModalContainer />
      </div>
    </React.Fragment>
  }
}
export default compose(withStyles(styles))(Admin);
